import React from "react";
import _ from "lodash";
import moment from "moment";
import cx from "classnames";
import { withTranslation } from "react-i18next";
import submit from "submit-form";
import Modal from "../modal-new";
import DateInput from "../../parts/inputs/date-input";
import { RillContext } from "../../rill/RillReact/share/base";

class addToCalendarModal extends React.Component {
  constructor(props, ctx) {
    super(props, ctx);
    this.state = {
      allSelected: false,
      selectedProgramCount: 0,
    };

    this.flash = ctx.locals.flash;
    this.onChange = this.onChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.generateDates = this.generateDates.bind(this);
    this.handleSelectAll = this.handleSelectAll.bind(this);
  }
  componentWillMount() {
    // Get the cycle. If coming from the program library, we don't have access to editCycle
    this.cycle = this.context.locals.editCycle
      ? this.context.locals.editCycle
      : this.props.cycle;
    const programs = this.cycle.programs;
    const allSelected = this.context.locals.query.wholeCycle === true;
    let amountSelected = 0;
    const formPrograms = programs.map((program) => {
      const selected =
        allSelected || program.order === this.context.locals.query.program
          ? true
          : false;
      if (selected) amountSelected++;
      return {
        name: program.name,
        order: program.order,
        sessions: program.sessions,
        startDate: undefined,
        endDate: undefined,
        days: [],
        isValid: false,
        selected,
        earliestStartDate: undefined,
        cycleId: this.cycle._id,
      };
    });
    this.setState({
      formPrograms,
      allSelected,
      selectedProgramCount: amountSelected,
    });
  }

  onChange(e, order, blockedDates = []) {
    // date-input passes the start date to this function as the e variable
    const name = e.target ? e.target.name : e;
    const formPrograms = this.state.formPrograms;

    // Find the program being edited
    const programIndex = _.findIndex(
      formPrograms,
      (program) => program.order === order
    );
    const program = formPrograms[programIndex];
    let allSelected = this.state.allSelected;
    // Update the program in state.formPrograms
    switch (name) {
      case "days": { // User clicked on a week day
        const dayIndex = program.days.indexOf(e.target.value);
        if (dayIndex > -1) {
          program.days.splice(dayIndex, 1);
        } else {
          // Only add day if the user hasn't already selected enough days
          if (
            program.days.length <
            _.max(_.map(program.sessions, (session) => session.order))
          ) {
            let isValidDate = true;

            // Prevent selection if it will result in overlapping programs
            if (
              program.startDate &&
              program.days.length ===
                _.max(_.map(program.sessions, (session) => session.order)) - 1
            ) {
              const potentialWeekDays = [...program.days, e.target.value];
              const potentialDates = this.generateDates(
                program.sessions,
                program.days.length ? potentialWeekDays : [e.target.value],
                program.startDate,
                "days"
              );
              const lastProgramDate = moment(_.last(potentialDates));
              const firstProgramDate = moment(potentialDates[0]);

              blockedDates.map((blockedProgram) => {
                const dates = blockedProgram.dates;
                // Check if any of the potential program dates are between the first and last blocked date
                if (dates[0]) {
                  const lastDateOverlaps =
                    lastProgramDate.isAfter(moment(dates[0]).add(-1, "days")) &&
                    lastProgramDate.isBefore(
                      moment(_.last(dates)).add(1, "days")
                    );
                  const firstDateOverlaps =
                    firstProgramDate.isAfter(
                      moment(dates[0]).add(-1, "days")
                    ) &&
                    firstProgramDate.isBefore(
                      moment(_.last(dates)).add(1, "days")
                    );
                  if (lastDateOverlaps || firstDateOverlaps) {
                    isValidDate = false;
                  }
                }
              });
            }
            if (!isValidDate) {
              this.flash("error", this.props.t("addToCalendar.overlappingProgramsError"));
              submit("/actions/refresh");
            } else {
              program.days.push(e.target.value);
            }
          }
        }
        break;
      }
      case "selected": // User clicked on check mark to select a program
        if (program.selected) {
          this.setState({
            selectedProgramCount: this.state.selectedProgramCount - 1,
          });
        } else {
          this.setState({
            selectedProgramCount: this.state.selectedProgramCount + 1,
          });
        }
        program.selected = !program.selected;
        if (!program.selected && allSelected) allSelected = false;
        break;
      default:
        // User picked a start date
        program.startDate = moment(e).format("YYYY-MM-DD");
    }

    program.isValid = this.isValid(program);
    if (program.isValid) {
      program.dates = this.generateDates(
        program.sessions,
        program.days,
        program.startDate
      );
    } else {
      program.dates = [];
    }
    formPrograms[programIndex] = program;
    this.setState({ formPrograms, allSelected });
  }

  isValid(program) {
    // Check if the program is selected, has a start date, and has the right number of weekdays selected
    const daysToSelect = _.max(
      _.map(program.sessions, (session) => session.order)
    );
    return (
      program.selected &&
      program.startDate &&
      program.days.length === daysToSelect
    );
  }

  generateDates(sessions, weekDays, startDate, referrer) {
    const weekDays2 = _.clone(weekDays);
    //return an array of workout dates for a program
    // this is necessary for uneven sessions per week: see MSB-969 (This has an api component as weel see - cycle-add-to-calendar)
    const numberOfWeeks = _.max(_.map(sessions, (session) => session.week));
    const numberOfDays = numberOfWeeks * 7;

    let dateToCheck = moment.utc(startDate);
    const dates = [];
    let count = 0;
    while (count < numberOfDays) {
      if (weekDays.indexOf(dateToCheck.day().toString()) > -1)
        dates.push(moment.utc(dateToCheck).format("YYYY-MM-DD"));
      dateToCheck = dateToCheck.add(1, "days");
      count += 1;
      if (count > 200) break; // #breakloopsnotbrowsers
    }
    return dates;
  }

  handleSelectAll() {
    const formPrograms = this.state.formPrograms;
    if (!this.state.allSelected) {
      formPrograms.forEach(
        (program, programIndex) => (formPrograms[programIndex].selected = true)
      );
      this.setState({
        formPrograms,
        allSelected: true,
        selectedProgramCount: formPrograms.length,
      });
    } else {
      formPrograms.forEach(
        (program, programIndex) => (formPrograms[programIndex].selected = false)
      );
      this.setState({
        formPrograms,
        allSelected: false,
        selectedProgramCount: 0,
      });
    }
  }

  handleSubmit(e) {
    e.preventDefault();
    // this is to block multiple clicks firing simultaneous add to calendar
    if (this.addingInProgress) return;
    this.addingInProgress = true;
    return new Promise((resolve, reject) => {
      const activeExercises = this.context.locals.activeExercises;
      const datesToSchedule = _.compact(
        _.flatten(
          this.state.formPrograms.map((program) => {
            return program.dates;
          })
        )
      );

      let willOverwrite = false,
        daysToBeOverwritten = [];
      activeExercises.map((exercise) => {
        datesToSchedule.map((date) => {
          date = moment.utc(date);
          if (
            moment.utc(exercise.utcDate.toString()).format("DD MM YYYY") ===
            date.format("DD MM YYYY")
          ) {
            willOverwrite = true;
            daysToBeOverwritten.push(date.format("YYYY-MM-DD"));
          }
        });
      });

      if (!willOverwrite) {
        resolve(
          submit(`/actions/cycle/add-to-calendar/${this.cycle._id}`, {
            method: "POST",
            body: { formPrograms: this.state.formPrograms },
          })
        );
      }

      if (
        willOverwrite &&
        confirm(this.props.t("addToCalendar.overwriteConfirm"))
      ) {
        resolve(
          submit(`/actions/cycle/add-to-calendar/${this.cycle._id}`, {
            method: "POST",
            body: {
              formPrograms: this.state.formPrograms,
              daysToBeOverwritten,
            },
          })
        );
      }
    });
    // .then(() => this.addingInProgress = false )
  }

  render() {
    const { t } = this.props;
    const cycle = this.cycle;
    const exercises = this.context.locals.activeExercises;
    const {
      activeUser: { repMaximums, units },
      fromMetric,
      withWeight,
    } = this.context.locals;
    const selectedAmount = 0;
    const programs = this.state.formPrograms;

    const { selectedProgramCount } = this.state;
    let validProgramCount = 0;

    const blockedDates = [];
    programs.map((program) => {
      validProgramCount += program.isValid ? 1 : 0;

      if (program.dates) {
        blockedDates.push({
          cycleId: cycle._id,
          program: program.order,
          isFormProgram: true,
          dates: program.dates,
        });
      }
    });

    // Add dates from already scheduled programs to blockedDates
    const exercisesByCycle = _.groupBy(exercises, (exercise) => {
      if (exercise.cycle) return exercise.cycle.id;
      return "singleton";
    });

    // If a user has added the same cycle twice
    // Exercises from different instances of the same cycle will be grouped; split them apart
    // MSB-761
    Object.keys(exercisesByCycle).forEach((key) => {
      const cycleExercises = _.sortBy(exercisesByCycle[key], "date");
      const sliceHere = []; // The points where the exercises from one cycle end, and another begins
      cycleExercises.forEach((exercise, exInd) => {
        if (!exercise.cycle || exInd > cycleExercises.length - 2) return;
        // If the week for an exercise is greater than the one after it, that means
        // that's the end of one cycle
        if (
          exercise.cycle.programWeek >
          cycleExercises[exInd + 1].cycle.programWeek
        ) {
          sliceHere.push(exInd + 1);
        }
      });
      if (sliceHere.length) {
        // Slice the exercise and assign them to a new key in exercisesByCycle
        // Different slices of the same array are exercises from the same cycle, scheduled multpiple times
        exercisesByCycle[key] = cycleExercises.slice(0, sliceHere[0]);
        for (let i = 0; i < sliceHere.length; i++) {
          const endOfSlice =
            i < sliceHere.length - 1 ? sliceHere[i + 1] : cycleExercises.length;
          exercisesByCycle[key + String(i)] = cycleExercises.slice(
            sliceHere[i],
            endOfSlice
          );
        }
      }
    });

    const exercisesByProgram = _.map(exercisesByCycle, (cycleExercises) => {
      return _.groupBy(cycleExercises, (exercise) => {
        if (exercise.cycle) return exercise.cycle.program;
        else return "singleton";
      });
    });

    exercisesByProgram.map((cycle, i) => {
      for (const key in cycle) {
        if (key !== "singleton")
          blockedDates.push({
            isFormProgram: false,
            dates: cycle[key].map((exercise) =>
              moment.utc(exercise.utcDate.toString()).format("YYYY-MM-DD")
            ),
          });
      }
    });

    return (
      <form
        action=""
        method="POST"
        data-noreset
        onSubmit={(e) => this.handleSubmit(e)}
      >
        <Modal
          title={t("addToCalendar.title")}
          canClose={this.props.disableClose ? false : true}
          className={"add-to-calendar"}
        >
          <div className="body">
            <header className="flex justify-between">
              <hgroup>
                <p className="s1 mb-2">{cycle.name}</p>
                <p className="s1 clipped w-fit">{cycle.createdBy.name || ""}</p>
              </hgroup>
              <hgroup className="rm-details">
                <p className="s1 mb-2 text-right">{t("addToCalendar.repMaximums")}</p>
                <p className="flex gap-2">
                  <span className="text-(--squat)">
                    Squat {withWeight(fromMetric(repMaximums["squat"]))}
                  </span>
                  <span className="text-(--bench)">
                    Bench {withWeight(fromMetric(repMaximums["bench"]))}
                  </span>
                  <span className="text-(--deadlift)">
                    Deadlift {withWeight(fromMetric(repMaximums["deadlift"]))}
                  </span>
                </p>
              </hgroup>
            </header>
            <article>
              <header className="flex justify-between">
                <label className="checkbox-input opacity-100!">
                  <input
                    type="checkbox"
                    checked={
                      this.state.allSelected ||
                      programs.length == selectedProgramCount
                    }
                    onChange={this.handleSelectAll}
                  />

                  <span className="text">{t("addToCalendar.selectAllPrograms")}</span>
                </label>
                <a
                  role="button"
                  data-button-type="outline"
                  href="/dashboard/settings/exercise-library"
                >
                  <span>{t("addToCalendar.manageRMs")}</span>
                </a>
              </header>
            </article>
            <div className="Add-To-Calendar">
              <div className="cycle-details"></div>
              {programs.map((program) => (
                <AddCalendarProgramRow
                  program={program}
                  totalPrograms={programs.length}
                  selected={program.selected}
                  earliestStartDate={""}
                  onChange={this.onChange}
                  blockedDates={blockedDates}
                  generateDates={this.generateDates}
                  exercises={this.context.locals.activeExercises}
                  t={t}
                />
              ))}
            </div>
          </div>

          <footer>
            <a
              role="button"
              data-button-type="secondary"
              data-action-cancel
              className="button alt"
              href={`/actions/refresh?modal=`}
            >
              {t("common:cancel")}
            </a>
            <button
              type="submit"
              data-button-type="primary"
              disabled={selectedProgramCount < 1 || undefined}
            >
              {t("addToCalendar.addCount", { count: selectedProgramCount })}
            </button>
          </footer>
        </Modal>
      </form>
    );
  }
}

class AddCalendarProgramRow extends React.Component {
  constructor(props, ctx) {
    super(props, ctx);
    this.state = {
      startDate: props.earliestStartDate,
      days: props.days,
      isValid: false,
    };

    this.dateValidator = this.dateValidator.bind(this);
  }

  dateValidator(pickerDate, blockedDates, program, numberWeekdaystoSelect) {
    // DateInput runs this for every date, and disables that date if false is returned
    // If either the start date or the potential end date is within the
    // range of dates of another program, you can't choose it in the date picker.
    const { generateDates } = this.props;
    // calculate the endDate of the program
    const weekdaysToGenerate =
      program.days.length === numberWeekdaystoSelect
        ? program.days
        : ["0", "1", "2", "3", "4", "5", "6", "7"].splice(
            0,
            numberWeekdaystoSelect
          );
    const thisProgramDates = generateDates(
      program.sessions,
      weekdaysToGenerate,
      pickerDate
    ).map((date) => moment.utc(date));
    const lastProgramDate = thisProgramDates[thisProgramDates.length - 1];

    let isValidDate = true;
    blockedDates.forEach((blockedProgram, i) => {
      let isOwnProgram = false;
      const dates = blockedProgram.dates.sort();
      if (dates[0]) {
        // Don't block out a potential program's own dates
        if (
          blockedProgram.isFormProgram === true &&
          program.cycleId === blockedProgram.cycleId &&
          program.order === blockedProgram.program
        ) {
          isOwnProgram = true;
          // isValidDate = true;
        }
        // Check if date to validate is in program's date range
        if (
          pickerDate.isAfter(dates[0]) &&
          pickerDate.isBefore(moment(_.last(dates)).add(1, "days")) &&
          !isOwnProgram
        ) {
          isValidDate = false;
        }

        // Last day of potential new program is within program's date range
        if (
          lastProgramDate.isAfter(dates[0]) &&
          lastProgramDate.isBefore(moment(_.last(dates)).add(2, "days")) &&
          !isOwnProgram
        ) {
          isValidDate = false;
        }
      }
    });
    return isValidDate;
  }

  render() {
    const { program, totalPrograms, selected, onChange, blockedDates, t } =
      this.props;
    // days to select is the maximum of all session.order
    const daysToSelect = _.max(
      _.map(program.sessions, (session) => session.order)
    );
    const { days } = program;

    return (
      <section
        className={cx("program", {
          "alt-invalid": !(selected && program.isValid),
        })}
      >
        <label>
          <input
            name="selected"
            type="checkbox"
            checked={selected}
            onChange={(e) => onChange(e, program.order)}
          />
          {program.name}
        </label>

        <div className={cx({ "alt-disabled": !selected })}>
          <label className="opacity-70">{t("addToCalendar.chooseStartDate")}</label>
          <div role="calendar-date-selectors">
            <div role="date-selector-wrapper">
              <DateInput
                name="day"
                altPosition
                placeholder={t("addToCalendar.startDatePlaceholder")}
                min={moment(0)}
                onChange={(e) => onChange(e, program.order)}
                dateValidator={(date) =>
                  this.dateValidator(
                    moment(date),
                    blockedDates,
                    program,
                    daysToSelect
                  )
                }
                disabled={!program.selected}
              />
            </div>
          </div>
        </div>
        <div>
          <header>
            <label
              className={cx("", {
                "alt-invalid":
                  program.selected && program.days.length !== daysToSelect,
              })}
            >
              {t("addToCalendar.selectWorkoutDays", { count: daysToSelect })}
            </label>
            <label>
              {program.order} / {totalPrograms}
            </label>
          </header>
          <div className={`days-wrapper ${selected ? "" : "disabled"}`}>
            <div className="day">
              <label className="checkbox-input">
                <input
                  name="days"
                  value="0"
                  type="checkbox"
                  checked={days.indexOf("0") > -1}
                  disabled={
                    !selected ||
                    (days.length !== daysToSelect && days.indexOf("0") > -1)
                      ? true
                      : undefined
                  }
                  onChange={(e) => onChange(e, program.order, blockedDates)}
                />
              </label>
              <p className="p1">{t("addToCalendar.sunday")}</p>
            </div>
            <div className="day">
              <label className="checkbox-input">
                <input
                  name="days"
                  value="1"
                  type="checkbox"
                  checked={days.indexOf("1") > -1}
                  disabled={
                    !selected ||
                    (days.length !== daysToSelect && days.indexOf("1") > -1)
                      ? true
                      : undefined
                  }
                  onChange={(e) => onChange(e, program.order, blockedDates)}
                />
              </label>
              <p className="p1">{t("addToCalendar.monday")}</p>
            </div>
            <div className="day">
              <label className="checkbox-input">
                <input
                  name="days"
                  value="2"
                  type="checkbox"
                  checked={days.indexOf("2") > -1}
                  disabled={
                    !selected ||
                    (days.length !== daysToSelect && days.indexOf("2") > -1)
                      ? true
                      : undefined
                  }
                  onChange={(e) => onChange(e, program.order, blockedDates)}
                />
              </label>
              <p className="p1">{t("addToCalendar.tuesday")}</p>
            </div>
            <div className="day">
              <label className="checkbox-input">
                <input
                  name="days"
                  value="3"
                  type="checkbox"
                  checked={days.indexOf("3") > -1}
                  disabled={
                    !selected ||
                    (days.length !== daysToSelect && days.indexOf("3") > -1)
                      ? true
                      : undefined
                  }
                  onChange={(e) => onChange(e, program.order, blockedDates)}
                />
              </label>
              <p className="p1">{t("addToCalendar.wednesday")}</p>
            </div>
            <div className="day">
              <label className="checkbox-input">
                <input
                  name="days"
                  value="4"
                  type="checkbox"
                  checked={days.indexOf("4") > -1}
                  disabled={
                    !selected ||
                    (days.length !== daysToSelect && days.indexOf("4") > -1)
                      ? true
                      : undefined
                  }
                  onChange={(e) => onChange(e, program.order, blockedDates)}
                />
              </label>
              <p className="p1">{t("addToCalendar.thursday")}</p>
            </div>
            <div className="day">
              <label className="checkbox-input">
                <input
                  name="days"
                  value="5"
                  type="checkbox"
                  checked={days.indexOf("5") > -1}
                  disabled={
                    !selected ||
                    (days.length !== daysToSelect && days.indexOf("5") > -1)
                      ? true
                      : undefined
                  }
                  onChange={(e) => onChange(e, program.order, blockedDates)}
                />
              </label>
              <p className="p1">{t("addToCalendar.friday")}</p>
            </div>
            <div className="day">
              <label className="checkbox-input">
                <input
                  name="days"
                  value="6"
                  type="checkbox"
                  checked={days.indexOf("6") > -1}
                  disabled={
                    !selected ||
                    (days.length !== daysToSelect && days.indexOf("6") > -1)
                      ? true
                      : undefined
                  }
                  onChange={(e) => onChange(e, program.order, blockedDates)}
                />
              </label>
              <p className="p1">{t("addToCalendar.saturday")}</p>
            </div>
          </div>
        </div>
        {program.isValid && (
          <div className="duration">
            {t("addToCalendar.workoutDuration")}{" "}
            <span className="duration-period">
              {moment(program.dates[0]).format("MMM D")} -{" "}
              {moment(program.dates[program.dates.length - 1]).format("MMM D")}
            </span>
          </div>
        )}
      </section>
    );
  }
}

addToCalendarModal.contextType = RillContext;
AddCalendarProgramRow.contextType = RillContext;

export default withTranslation("coaching-portal")(addToCalendarModal);
